module.exports = "../images/hiking-fishing-lodge-ontario.jpg?v=a59c7a8";